// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wwosfhatkzqsgzhkigpx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind3b3NmaGF0a3pxc2d6aGtpZ3B4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU3Njc2ODYsImV4cCI6MjA2MTM0MzY4Nn0.oHJMMbMepYcQ3G-_vXg_GPLiU5_t9I0JYNr9JneJAQw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Create the Supabase client with proper configuration for browser environment
const options = {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'digital-synagogue-auth-storage'
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
};

// For browser environment, ensure we're using native WebSocket
if (typeof window !== 'undefined') {
  // @ts-ignore - We need to set this even if TypeScript doesn't like it
  options.realtime.WebSocketImpl = window.WebSocket;
}

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, options);